import styles from './style.module.scss';
import Modal from '../../components/Modal'
import { examRules } from '../../config/exam';
import Button from '../../components/Button';
import { useDispatch } from '../../store/store';
import { setExamRulesModal } from '../../store/exam/slice';

export default function ExamRules() {
    const dispatch = useDispatch();

    return (
        <Modal
            size='lg'
            title='Exam Rules'
            closeFunc={() => dispatch(setExamRulesModal(false))}
        >
            <div className={styles.examRules}>
                {examRules.map((i, indx) => (<div className={styles.rule}>
                    <span className={styles.rule_title}>{indx + 1}. {i.title}</span>
                    <span className={styles.rule_description}>{i.description1}</span>
                    <span className={styles.rule_description}>{i.description2}</span>
                </div>))}
                <p>
                    We highly recommend opening a browser with one tab for
                    the exam and closing all other browser windows and tabs.
                </p>
            </div>
            <div>
                <Button text='Confirm' onClick={() => dispatch(setExamRulesModal(false))} />
            </div>
        </Modal>
    )
}
